import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import {
  fixRotation,
  checkIsBase64,
  isFileTypeImage,
  removeMime,
} from '../../lib/helpers'
import { useAppStore } from '../../store/useAppStore'
import { useCache } from '../useCache'

export const useOnImageUpload = (tabValue, vehicleId) => {
  const cache = useCache()
  const { t } = useTranslation()
  const setSnackbar = useAppStore((state) => state.setSnackbar)
  const setVehicleData = useAppStore((state) => state.setVehicleData)
  const setLoading = useAppStore((state) => state.setLoading)

  const onImageReaderLoad = useCallback(
    () => (event: { target: { result: any } }) => {
      const {
        target: { result },
      } = event
      if (checkIsBase64(removeMime(result))) {
        const dateToday = new Date()

        setVehicleData((prevState) => ({
          ...prevState,
          [tabValue]: {
            ...prevState[tabValue],
            photo: result,
            date: dateToday,
          },
        }))

        cache.writeData(`${tabValue}-${vehicleId}-date`, dateToday)
        cache.writeData(`${tabValue}-${vehicleId}`, result)
      } else {
        setSnackbar({ open: true, message: t('snackbar.something_went_wrong') })
      }
      setLoading(false)
    },
    [setLoading, setVehicleData, cache, tabValue, vehicleId, setSnackbar, t]
  )

  const onImageUpload = useCallback(
    (event) => {
      setLoading(true)
      const { target } = event
      if (target.files.length) {
        // Check file type
        if (isFileTypeImage(target.files[0].type)) {
          // Fix rotation of captured image
          let myRotationFunction = async function (fileToBeRotated) {
            try {
              let blob
              let imageToUpload = fileToBeRotated
              if (HTMLCanvasElement.prototype.toBlob) {
                blob = await fixRotation(fileToBeRotated)
                imageToUpload = blob
              }
              const reader = new FileReader()

              reader.onload = onImageReaderLoad()
              reader.readAsDataURL(imageToUpload)
              reader.onerror = (error) => console.log(error)
            } catch (error) {
              throw new Error(error.message)
            }
          }

          myRotationFunction(target.files[0]).catch((err) => {
            setLoading(false)
            setSnackbar({
              open: true,
              message: t('snackbar.something_went_wrong'),
            })
            console.dir(err)
          })
        }
      }

      // reset input
      event.target.value = null
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [onImageReaderLoad, setLoading, setSnackbar, t]
  )

  return onImageUpload
}
